import React from 'react';
import WalletConnectButton from './WalletConnectButton';

const Header = () => {
  return (
    <header className="header">
      <div className="header-content">
        <div className="header-text">
          <h1>OrAi</h1>
          <p>A mysterious portal into the depths of the blockchain. Enter if you dare to discover what OrAi sees in your digital soul.</p>
        </div>
        <div className="header-wallet">
          <WalletConnectButton />
        </div>
      </div>
    </header>
  );
};

export default Header; 